import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

import { onMounted, watch, computed, ref } from "vue"
  import { useRoute } from "vue-router"
  import { useNewsFeedStore } from "@/store/newsfeed"
  import { IonContent, loadingController, IonInfiniteScroll, IonInfiniteScrollContent, IonPage } from "@ionic/vue"
  import ThoughtLeadershipContainer from "@/components/workbean-page/home/ThoughtLeadership.vue"
  import EmployeeAmbassadorshipContainer from "@/components/workbean-page/home/EmployeeAmbassadorship.vue"
  import Insights from "@/components/world-feed/InsightContainer.vue"
  import router from "@/router"
  import PostTemplate from "@/components/template/PostTemplate.vue"
  import HeaderNav from "@/components/menuBar.vue"

  // image

  
export default /*#__PURE__*/_defineComponent({
  __name: 'WorldFeed',
  setup(__props) {

  const newsfeedStore = useNewsFeedStore()
  const feedList = computed(() => newsfeedStore.newsfeedList)
  const route = useRoute()
  const path = computed(() => route.params.id)

  const newsFeedParams = ref({
    feed: "",
    company: "",
    user: "",
    limit: 5,
    page: 1,
  })

  const loadData = async () => {
    newsFeedParams.value.page += 1
    newsfeedStore.isNewState = false
  }

  const initPosts = async () => {
    const loading = await loadingController.create({
      spinner: null,
      message: "Retrieving...",
      translucent: true,
      backdropDismiss: false,
    })
    await loading.present()
    await newsfeedStore.retrieveFeed(newsFeedParams.value)
    loading.dismiss()
  }

  onMounted(async () => {
    if (!path.value && router.currentRoute.value.fullPath.includes("/workbean-world")) initPosts()
  })

  watch(newsFeedParams, () => initPosts(), { deep: true })

return (_ctx: any,_cache: any) => {
  const _component_ion_list = _resolveComponent("ion-list")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { class: "ion-padding" }, {
        default: _withCtx(() => [
          _createVNode(HeaderNav),
          _createVNode(_component_ion_list, { lines: "none" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(feedList), (feed, index) => {
                return (_openBlock(), _createBlock(PostTemplate, {
                  key: `${index}_feed`,
                  "post-data": feed,
                  "post-page-location": "world"
                }, {
                  default: _withCtx(() => [
                    (!feed.answer_content && feed.content.html)
                      ? (_openBlock(), _createBlock(Insights, {
                          key: 0,
                          id: feed.newsfeed_id,
                          "html-link": feed.content.html
                        }, null, 8, ["id", "html-link"]))
                      : (feed.answer_content && feed.answer_content.answer && feed.answer_content.answer.answers && feed.answer_content.answer.answers.length > 0)
                        ? (_openBlock(), _createBlock(EmployeeAmbassadorshipContainer, {
                            key: 1,
                            "user-answers": feed.answer_content,
                            likes: feed.likes,
                            shares: feed.shares,
                            post_id: feed.newsfeed_id
                          }, null, 8, ["user-answers", "likes", "shares", "post_id"]))
                        : (feed.answer_content && feed.answer_content.answer && feed.answer_content.answer.answer)
                          ? (_openBlock(), _createBlock(ThoughtLeadershipContainer, {
                              key: 2,
                              "post-id": feed.newsfeed_id,
                              user: feed.answer_content.user,
                              answer: feed.answer_content.answer,
                              company: feed.answer_content.company
                            }, null, 8, ["post-id", "user", "answer", "company"]))
                          : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["post-data"]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_unref(IonInfiniteScroll), {
            id: "infinite-scroll",
            threshold: "100px",
            disabled: _unref(newsfeedStore).isLast,
            onIonInfinite: _cache[0] || (_cache[0] = ($event: any) => (loadData()))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonInfiniteScrollContent), {
                "loading-spinner": "bubbles",
                "loading-text": "Loading more data..."
              })
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})